module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('scroll', {
    ref: "scroll",
    attrs: {
      "data": _vm.toplist
    }
  }, [_c('ul', {
    staticClass: "toplist"
  }, _vm._l((_vm.toplist), function(list) {
    return _c('router-link', {
      key: list.path,
      staticClass: "item",
      attrs: {
        "tag": "li",
        "to": {
          path: ("ranking/" + (list.path))
        }
      }
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('img', {
      attrs: {
        "width": "100",
        "height": "100",
        "src": list.icon,
        "alt": "没有图片"
      }
    })]), _vm._v(" "), _c('ul', {
      staticClass: "songlist"
    }, _vm._l((list.item), function(item, index) {
      return _c('li', {
        key: item.album_id
      }, [_c('span', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title) + "-" + _vm._s(item.artist_name))])])
    }))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4393e231"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/toplist/toplist.vue
// module id = 200
// module chunks = 1